import { Injectable } from '@angular/core';
import { BaseHubService } from './base-hub.service';
import { SessionEdition } from '../../_models/SessionEdition';
import { IBaseObject } from '../../_models/BaseObject';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../_store/mainStoreState';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../local/message.service';
import { ConfigService } from '../local/config.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { setSessionEditionAction } from '../../_store/SessionStore/session.store';

@Injectable({
  providedIn: 'root',
})
export class SessionEditionService extends BaseHubService<SessionEdition> {
  constructor(
    private store: Store<MainStoreState>,
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super(
      'session',
      'hubs/sessionEdition',
      `Session d'édition`,
      http,
      messageService,
      configService
    );
  }

  take(): Observable<boolean | undefined> {
    return this.http.get<boolean | undefined>(this.baseUrl + '/prendre').pipe(
      catchError((error) => this.handleError(error)),
      map((res) => (res === undefined ? undefined : true))
    );
  }

  release(): Observable<boolean | undefined> {
    return this.http.get<boolean | undefined>(this.baseUrl + '/relacher').pipe(
      catchError((error) => this.handleError(error)),
      map((res) => (res === undefined ? undefined : true))
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setSessionEditionAction({ payload: data as SessionEdition[] })
    );
  }
}
